<app-download-up></app-download-up>

<p>Заповнюйте назву населеного пункту лише українською без використання цифр (щонайменше 2 літери)</p>

<div class="container">
  <div class="row" >
    <form class='col-lg-6 col-12' #form="ngForm" (ngSubmit)="submit( form )"  autocomplete="off" >
      <form-city-select [form]='form' (newValue)="saveInputValue('city', $event )" class="margin-bottom" ></form-city-select>
      <street-select [form]='form' (newValue)="saveInputValue('street', $event )"></street-select>
      <house-select [form]='form' [indexSync]='indexSync' (newValue)="saveInputValue('house', $event )" ></house-select>
      <button type='submit' class='submitButton col-md-12 col-xs-12' [disabled]="!(streetValue&&houseValue&&cityValue)" >Знайти</button>
    </form>

    <response-index-loader id="indexResponse" [responseSubject]="indexResponseSubject" [clear]="requestForDataPosted" class="loader no-side-padding col-md-6 col-xs-12" ></response-index-loader>
  </div>
</div>

<div class="link-list">
    <a href="/find-address" class="link-grey">Знайти адресу за індексом</a>
    <a href="https://offices.ukrposhta.ua/" class="link-grey">Знайти відділення</a>
    <a href="/postcodes-and-offices" class="link-grey">Довідка</a>
</div>

<div class="row">
    <div class="col-lg-6">
        <div class="buttonsContainer">
            <download-button class="downloadButtonMain" label='Перелік поштових індексів' link="https://www.ukrposhta.ua/files/shares/out/postindex.zip" ></download-button>
        </div>

        <div class="buttonsContainer">
            <download-button class="downloadButtonMain" label='Довідник поштових адрес' link="https://www.ukrposhta.ua/files/shares/out/houses.zip" ></download-button>
        </div>
    </div>
</div>
